export default __webpack_public_path__ + "static/media/book-5901941_1920.5049adcc.jpg";